import React from "react";
import PropTypes from "prop-types";

class Tabs extends React.Component {
    render() {
        const {
            isIndustryActive,
            toggleTabs,
            isProductActive,
        } = this.props;
        return (
            <section className="tabs">
                <div className="wrapper container">
                    <button
                        className={`tab ${
                            isIndustryActive ? "is-active" : ""
                        }`}
                        title="Industries"
                        onClick={toggleTabs}
                    >
                        By Industry
                    </button>
                    <button
                        className={`tab ${
                            isProductActive ? "is-active" : ""
                        }`}
                        title="Products"
                        onClick={toggleTabs}
                    >
                        By Product
                    </button>
                </div>
            </section>
        );
    }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs.js